import { render, staticRenderFns } from "./SpuEdit.vue?vue&type=template&id=207229d9&scoped=true&"
import script from "./SpuEdit.vue?vue&type=script&lang=js&"
export * from "./SpuEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207229d9",
  null
  
)

export default component.exports